export default __webpack_public_path__ + "static/media/3.8ac9dd10.png";